import type { PublicApiKey } from '#packages/apilib';
import type { createHelpWidgetApi } from './helpWidgetApi';

export const HelpWidgetApiKey: PublicApiKey<typeof createHelpWidgetApi> = {
  name: 'HelpWidgetApi',
  public: true,
};
